module.exports = __webpack_public_path__ + "img/gsb.6be0d830.svg";